<template>
    <div class=''>
        <!-- 设置登录信息 -->
        <div>
            <div class="login-input">
                <input v-model="loginName" placeholder="请设置登录账号，仅限字母、数字，例如 “huawei001” " @blur="checkInput('loginName')" maxlength="20"/>
                <span class="login-err" v-show="loginNameErr">登录账号只能由字母、数字组成，且不小于8位</span>
                <span class="login-input-length">{{loginName.length}}/20</span>
            </div>
            <div class="login-input flexStart">
                <input v-model="code" placeholder="请输入手机验证码" @keyup.enter="login" @blur="checkInput('code')" maxlength="6" style="flex:1;margin-right:30px;"/>
                <div>
                    <button-load @clickHandle="getInviteCode"  type="primary" :disabled="countDisabled" :lable="counter > 0? counter + 's 后重新获取' : '获取验证码'"></button-load>
                </div>
                <span class="login-err" v-show="codeErr">验证码不能为空</span>
                <span class="login-input-length" style="right:156px;" maxLength='6'>{{code.length}}/6</span>
            </div>
            <div class="login-input">
                <input v-model="password" type="password" placeholder="请输入密码" @blur="checkInput('password')" maxlength="20"/>
                <span class="login-err" v-show="passwordErr">字母/数字/特殊字符(~!@#$%^&*()_.)中至少两种组成，8-20位</span>
                <span class="login-input-length">{{password.length}}/20</span>
            </div>
            <div class="login-input">
                <input v-model="confirmPswd" type="password" placeholder="请再次输入密码" @blur="checkInput('confirmPswd')" maxlength="20"/>
                <span class="login-err" v-show="confirmPswdErr">{{confirmPswd.length==0?"密码不能为空":"两次输入密码不一致"}}</span>
                <span class="login-input-length">{{confirmPswd.length}}/20</span>
            </div>
            <div class="login-input">
                <input v-model="email" placeholder="请输入邮箱" @blur="checkInput('email')"/>
                <span class="login-err" v-show="emailErr">请输入正确的邮箱</span>
            </div>
            <span class='text-color-red text-size-12' style="position: absolute;">{{errMsg}}</span>
            <div class="login-btn-box">
                <a-button :loading="loadLogin" type="primary" @click="checkRegister" class="login-btn" :disabled="!checkInput()">下一步</a-button>
                <div class="login-register"><span @click="toRegister">登 录</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { saveUserInf } from "@/api/register.js";
import {getCaptcha} from "@/api/security.js";
import { JSEncrypt } from "jsencrypt";
import { systemDate } from "@/api/communal";
export default {
    name:"register-save",
    data() {
        return {
            pubKey:
                "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJs93/+qTGnMr68IZoEZjmwlkiJ5lhD+HE6GQMiu/giAjCthA2G8+ri679/FmsryLXqUOEUSYBVmkl2gjmD8XhgYx9BEfO00qhz5uvnhTLNN4RKha8Epsx07EqTm6+LWYdFwuf4MIlKVy3B1YZN9qamyWelXoiDILtf78vFLvnOQIDAQAB",
            encrypt: new JSEncrypt(),
            sequence:"",
            modalShow:false,
            loadLogin:false,
            counter:0,
            countDisabled:false,
            errMsg:"",

            loginName:"",
            loginNameErr:false,
            codeErr:false,
            code:"",
            passwordErr:false,
            password:"",
            confirmPswdErr:false,
            confirmPswd:"",
            emailErr:false,
            email:""
        };
    },
    computed: {},
    methods: {
        ...mapMutations({
            setUserObj: "home/setUserObj",
        }),
        checkInput(type){
            switch(type){
                case "loginName":
                this.loginNameErr = (this.loginName.length<8 || !this.utils.regExpObj.ALPHABET_NUMBER_PATTERN.test(this.loginName)); break;
                case "code":
                this.codeErr = (this.code.length == 0); break;
                case "password":
                this.passwordErr = (!this.utils.regExpObj.PASSWORD_PATTERN.test(this.password)); break;
                case "confirmPswd":
                this.confirmPswdErr = (this.confirmPswd.length == 0 || this.confirmPswd != this.password); break;
                case "email":
                this.emailErr = (!this.utils.regExpObj.EMAIL_PATTERN.test(this.email)); break;
                default:
                return this.loginName.length>=8
                && this.utils.regExpObj.ALPHABET_NUMBER_PATTERN.test(this.loginName)
                && this.code.length
                && this.password==this.confirmPswd
                && this.utils.regExpObj.PASSWORD_PATTERN.test(this.password)
                && this.utils.regExpObj.EMAIL_PATTERN.test(this.email);
            }
        },
        countTimmer(init){
            if(init) {
                this.countDisabled = true;
                this.counter = 60;
            }
            if(this.counter > 0){
                setTimeout(() => {
                    this.counter --;
                    this.countTimmer();
                },1000)
            }else{
                this.countDisabled = false;
            }
        },
        varyCode() {
            this.sequence = Math.floor(Math.random() * 1e13);
        },
        getInviteCode(btn){
            const params = {
                target: this.$parent.checkInfo.ctcPsnTel,
                mode: 'SMS',
                type: 'reg',
            };
            getCaptcha(params).then(res => {
                btn.closeLoad();
                this.$message.success("验证码已发送");
                this.countTimmer(true);
            }).catch(err => {
                btn.closeLoad();
                console.log(err);
            });
        },
        checkRegister() {
            this.loadLogin = true;
            const param = {
                code: this.code,
                confirmPswd: this.utils.getPasswordEncryptString(this.confirmPswd),
                cstNm: this.$parent.checkInfo.cstNm,
                cstOrgCode: this.$parent.checkInfo.cstOrgCode,
                ctrFlag: true,
                email: this.email,
                inviteCode: this.$parent.checkInfo.inviteCode,
                jfCode: "reg",
                loginName: this.loginName,
                mobile: this.$parent.checkInfo.ctcPsnTel,
                password:this.utils.getPasswordEncryptString(this.password),
            }
            saveUserInf(param).then(res => {
                this.$message.success("注册成功，即将跳转登录页面...");
                setTimeout(() => {
                    this.$router.push("/login");
                    this.loadLogin = false;
                },1000)
                
            }).catch(err => {
                this.loadLogin = false;
                this.errMsg = err.description;
            })
        },
        showModal() {
            this.$parent.showModal();
        },
        modalCancel(e) {
            this.modalShow = false;
        },
        toRegister(){
            this.$router.push("/login")
        },
    },
    created() {},
    mounted() {}
}
</script>
<style scoped>

footer{
    position: absolute;
    bottom:0;
    line-height: 40px;
    width: 100%;
    color: #fff;
    background: rgba(0,0,0,0.3);
}
.footer-text{
    width: 80%;
    margin:0 auto;
}
.login-input{
    margin:20px 0 0;
    line-height: 40px;
    position: relative;
}
.login-err{
  position: absolute;
  color:red;
  left: 0;
  bottom: -32px;
  font-size: 12px;
  transition: all ease 0.4s;
}
.login-input input{
    width: 100%;
    border:none;
    outline: none;
    border-bottom:1px solid #ddd;
    line-height: 40px;
    height: 40px;
}
.login-input input:focus{
    border-color: #1990FF;
    transition: border-color 0.5s ease;
    -moz-transition: border-color 0.5s ease;	/* Firefox 4 */
    -webkit-transition: border-color 0.5s ease;	/* Safari 和 Chrome */
    -o-transition: border-color 0.5s ease;
}
.login-input-focus::after{
    content: '';
    display: inline-block;
    width: 100%;
    height: 1px;
    background-color:  #1990FF;
    transition: all 0.5s ease;
}
.login-btn-box{
    margin:24px 0 6px;
    font-size: 14px;
}
.login-btn{
    width: 100%;
    border:none;
    height: 44px;
    font-size: 18px;
}
.login-register{
    color: #1890ff;
    cursor: pointer;
    text-align: center;
    margin-top: 20px;
}
.login-forget{
    color:#999;
    text-decoration: underline;
    cursor: pointer;
}
.login-input-length{
  position: absolute;
  top:6px;
  right: 20px;
  color: #d8d8d8;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components-frame/register-save.vue